export const expander = `
  <button type="button"
          skin="hoshi"
          class="Button Button-primary"
          @click="expand(cell.val, index, row)">
    <i class="fa"
       v-bind:class="{'fa-plus': !expanded, 'fa-minus': expanded }"></i>
  </button>
`
export const html = `
  <span>{{ cell.val }}</span>
`



// WEBPACK FOOTER //
// ./src/components/tables/_shared/partials.js